module.exports = __webpack_public_path__ + "static/images/live-goods-icon1.93ca52a.png";